import React from 'react';
import { useModifySystemSpecification, useSystemSpecification } from '../../../ReactData/system';
import { useL10n } from '@ews/react-localization-context';
import SettingsCheckbox from '../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox';
import { TooltipIcon } from '../../../ToolTip/useTooltip';

const DisplaySettings: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();
    return <>

        <SettingsCheckbox
            text={t("[SID_EV_TECHN_MESS_ALARM]")}
            tooltip={<TooltipIcon text={t("[SID_EV_TECHN_MESS_ALARM]")} />}
            checked={specification.displaySettings?.displayTechnicalMessage || false}
            onChange={(checked) =>
            {
                if (specification.displaySettings?.displayTechnicalMessage === checked) return;
                if (systemId && specification.displaySettings) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        displaySettings: {
                            ...specification.displaySettings,
                            displayTechnicalMessage: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_FAULTALARM_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_FAULTALARM_LABEL")} />}
            checked={specification.displaySettings?.displayFaultAlarm || false}
            onChange={(checked) =>
            {
                if (specification.displaySettings?.displayFaultAlarm === checked) return;
                if (systemId && specification.displaySettings) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        displaySettings: {
                            ...specification.displaySettings,
                            displayFaultAlarm: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_PREALARM_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_PREALARM_LABEL")} />}
            checked={specification.displaySettings?.displayPreAlarm || false}
            onChange={(checked) =>
            {
                if (specification.displaySettings?.displayPreAlarm === checked) return;
                if (systemId && specification.displaySettings) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        displaySettings: {
                            ...specification.displaySettings,
                            displayPreAlarm: checked
                        },
                    });
                }
            }} />
    </>;
};

export default DisplaySettings;
